import React from 'react';
import ActivityIndicator from '../../Components/ActivityIndicator';
import GoaCP from '../../Assets/v2/ThreeHundred/GoaChannelPartner.jpg';
import BiharJharkhandCP from '../../Assets/v2/ThreeHundred/BiharJharkhandChannelPartner.jpg';
import './style.css';

class ChannelPartners extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true
    };
  }

  onImageLoad = () => {
    this.setState({
      isLoading: false
    });
  };

  render() {
    return (
      <div className="channel-partners-container">
        <div className="channel-partner">
          <h1>Goa</h1>
          <div className="img-box">
            <img
              onLoad={this.onImageLoad}
              className="img"
              src={GoaCP}
              alt="Goa Channel Partner"
            />

            {this.state.isLoading && (
              <div className="loader">
                <ActivityIndicator size="large" />
              </div>
            )}
          </div>
        </div>

        {/* <div className="channel-partner">
          <h1>Bihar &amp; Jharkhand</h1>
          <div className="img-box">
            <img
              onLoad={this.onImageLoad}
              className="img"
              src={BiharJharkhandCP}
              alt="Bihar & Jharkhand Channel Partner"
            />

            {this.state.isLoading && (
              <div className="loader">
                <ActivityIndicator size="large" />
              </div>
            )}
          </div>
        </div> */}
      </div>
    );
  }
}
export default ChannelPartners;



// WEBPACK FOOTER //
// ./src/Pages/ChannelPartners/index.js